/* GH-1133 S5 (design §3.10): the client side of the preview_* funnel events.
   Every name goes through PREVIEW_EVENT_NAMES so a typo can never create a
   new, unlisted event (the gateway admin view whitelists names one by one).
   No Google Ads mapping here — GH-1130 owns gtag. Fail-silent like funnel.js. */
import { track, trackOnce } from './funnel.js';
import { PREVIEW_EVENT_NAMES } from './freePreview.js';

const KNOWN = new Set(PREVIEW_EVENT_NAMES);

export function trackPreview(name, props = {}) {
  if (!KNOWN.has(name)) return;
  try { track(name, props); } catch { /* fail-silent */ }
}

export function trackPreviewOnce(name, props = {}, scopeKey) {
  if (!KNOWN.has(name)) return;
  try { trackOnce(name, props, scopeKey); } catch { /* fail-silent */ }
}
